module.exports = __webpack_public_path__ + "static/media/sunscreen.5f8b4cd9.png";